export default {"src":"/_next/static/media/institutional-page-banner.4c4f37af.svg","height":299,"width":395};